<template>
  <Breadcrumbs
      title="Order Management"
      :breadcrumbs="[
      { label: 'Order Management', path: '/orders' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <orderTable />
    </div>
  </div>
</template>

<script>
import orderTable from '@/pages/orders/orderTable.vue'
export default {
  name: 'indexList',
  components: {
    orderTable,
  },
}
</script>
